import {isEmpty, isObject} from 'lodash'

export const parseCssSelector = (name) => {
  if (isEmpty(name) || isObject(name))
    return ''

  return name
      .trim()
      .replace('/ ', '')
      .replace('(', '')
      .replace(')', '')
      .replace('.', '-')
      .replace('%', '')
      .replace('\'', '')
      .replace(/\s/g, '-').toLowerCase()
}

export const replaceAmpersandWithAnd = (text) => {
  return text.replace(/&/g, 'and')
}

/**
 * Get a CSS custom property (CSS variable) value from the document root
 * @param {string} variableName - The CSS variable name (with or without --)
 * @param {string} [fallback] - Optional fallback value if variable is not defined
 * @returns {string} The CSS variable value, trimmed
 *
 * @example
 * getCssVariable('--cg-color-primary-main') // '#E64A19'
 * getCssVariable('cg-color-primary-main')   // '#E64A19' (also works without --)
 * getCssVariable('--nonexistent', '#000')   // '#000' (fallback)
 */
export const getCssVariable = (variableName, fallback = '') => {
  // Ensure variable name starts with --
  const cssVarName = variableName.startsWith('--') ? variableName : `--${variableName}`

  // Get computed style from document root
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(cssVarName)
    .trim()

  return value || fallback
}
